import {Position} from './position.entity';
import {WorkerShort} from './workerShort.entity';
import {WorkerSocialLink} from './workerSocialLinks.entity';
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {HelperService} from '../services/helper.service';

export class Worker extends WorkerShort {
  birthday?: string;
  email?: string;
  filial?: string;
  gender?: string;
  phone?: string;
  onShift?: boolean = false;

  username?: string;

  @Type(() => WorkerSocialLink)
  socialLinks?: WorkerSocialLink = null;

  @Type(() => Position)
  posts?: Position[] = [];

  get positions() {
    return this.posts;
  }

  set positions(positions) {
    this.posts = positions;
  }

  get branch() {
    return this.filial;
  }

  set branch(branch) {
    this.filial = branch;
  }

  getPositionsList(separator: string = ' / ') {
    const returnData = [];
    if (this.posts.length) {
      this.posts.forEach((key: any, val: any) => {
        returnData.push(key.name);
      });
      return returnData.join(separator);
    } else {
      return null;
    }
  }

  getFormattedPhone(code: string = '+7'): string | null {
    return HelperService.getFormattedPhone(this.phone, code);
  }

  isSocialExist() {
    return this.socialLinks && Object.keys(this.socialLinks).some((key) => this.socialLinks[key]);
  }
}
